module.exports = __webpack_public_path__ + "static/media/IMG_0812.c739111a.jpg";